import './metrics_per_agent/metrics_per_agent_chart_view.js.coffee'

class CustomerVisualMode.Charts.AverageHandleAfterAssignedTimePerAgentChartView extends CustomerVisualMode.Charts.MetricsPerAgentChartView
  template: JST['backbone/templates/customer_visual_mode/charts/average_handle_after_assigned_time_per_agent_chart']
  className: 'grid-item full-width-chart average-handle-after-assigned-time-per-agent'
  @NAME: 'average_handle_after_assigned_time_per_agent'

  initialize: ({widget, title, dimensionName, description, data, session, isReadOnly, isResponsive}) ->
    super({
      widget,
      dimensionName: 'handle_after_assigned_time',
      templateTarget: '.average-handle-after-assigned-time-per-agent-metrics',
      description: I18n.t('customer_visual_mode.charts.average_handle_after_assigned_time_per_agent.description'),
      data,
      session,
      isReadOnly,
      isResponsive
    })

  _drilldownTitle: ->
    'Average handle time'
